module.exports = __webpack_public_path__ + "img/1.1.c1f92a2f.png";